// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const scovillain: PokeData = {
  "id": 952,
  "name": "scovillain",
  "height": 9,
  "weight": 150,
  "base_experience": 170,
  "types": [
    PokeType.GRASS,
    PokeType.FIRE
  ],
  "api_moves": [
    "headbutt",
    "leer",
    "bite",
    "flamethrower",
    "growth",
    "razor-leaf",
    "solar-beam",
    "sunny-day",
    "crunch",
    "overheat",
    "bullet-seed",
    "worry-seed",
    "seed-bomb",
    "fire-fang",
    "zen-headbutt",
    "leafage",
    "spicy-extract"
  ],
  "moves": [
    "headbutt",
    "leer",
    "bite",
    "flamethrower",
    "razor-leaf",
    "solar-beam",
    "sunny-day",
    "crunch",
    "bullet-seed",
    "fire-fang",
    "zen-headbutt",
    "ember",
    "morning-sun"
  ],
  "evolution_chain": {
    "id": 498,
    "item": null,
    "species": [
      {
        "name": "capsakid",
        "order": 938,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "scovillain",
        "order": 939,
        "types": [
          PokeType.GRASS,
          PokeType.FIRE
        ],
        "evolves_from_species_id": 951,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "fire-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 105,
    "speed": 121,
    "ability_power": 174
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
